import React, { useEffect, useState } from 'react';
import { DCheckbox, DMonth, DPage, DYear, useDMonth, useDYear } from "../../../../dum";
import { useSalesVsExpensesPageLazyQuery } from '../../../../../services';
import dayjs from 'dayjs';
import { Box } from '@mui/material';
import { ExpensesTable } from './expenses/expenses-table';
import { SalesTable } from './sales/sales-table';
import { UtilityTable } from './utility/utility-table';

export function SalesVsExpenses() {
    const [query, { data, loading }] = useSalesVsExpensesPageLazyQuery();
    const { year, setYear } = useDYear({
        COMPONENT_KEY: SalesVsExpenses.name + '_Year',
        defaultValue: dayjs().year(),
    });
    
    const { month, setMonth } = useDMonth({
        COMPONENT_KEY:  SalesVsExpenses.name + '_Month',
        defaultValue: dayjs().month(),
    });

    const [showDetails, setShowDetails] = useState(false);

    useEffect(() => {
        // Only query when BOTH year and month are actually selected. The old
        // guard used `!Number.isNaN(Number(month))`, but `Number(null)` is `0`
        // (a valid month), so clearing the month still fired a request for
        // January. Require a real month so "no month" means "no request".
        if (year != null && month != null) {
            void query({
                variables: {
                    year: Number(year),
                    month: month,
                },
            });
        }
    }, [query, year, month]);

    return (
        <DPage>
            <Box sx={{ display: 'flex', mt: 2, }}>
                <Box sx={{ mr: 2 }}>
                    {/* Not clearable: year/month are always set (initialized to
                        the current year/month), so a request always has both and
                        we never fire a partial (year-only) query. */}
                    <DYear setYear={setYear} year={year} clearable={false} />
                </Box>
                <Box sx={{ ml: 2, mr: 1 }}>
                    <DMonth
                        setMonth={setMonth}
                        month={month}
                        clearable={false}
                    />
                </Box>
                <Box
                    sx={{
                        ml: 2,
                        flexGrow: 1,
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    <DCheckbox
                        onChange={() => {
                            setShowDetails(!showDetails);
                        }}
                        value={showDetails}
                        label={'Mostrar Detalles'}
                    />
                </Box>
            </Box>



            <Box sx={{ my: 2,  width: '100%' }}>
                <UtilityTable salesVsExpensesQuery={data} loading={loading} />
            </Box>
            <Box sx={{ my: 2,  width: '100%' }}>

                <ExpensesTable
                    showDetails={showDetails}
                    salesVsExpensesQuery={data}
                    loading={loading}
                />
            </Box>
            <Box sx={{ my: 2,  width: '100%' }}>

                    <SalesTable
                        showDetails={showDetails}
                        salesVsExpensesQuery={data}
                        loading={loading}
                    />
            </Box>
        </DPage>
    );
}
